var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingBagInactive = function SvgShoppingBagInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.896 20.048V5.84h3.552v-.457c.016-.963.363-1.762 1.043-2.396.68-.634 1.516-.95 2.509-.95.993 0 1.83.316 2.51.95.679.634 1.027 1.433 1.042 2.396v.457h3.552v14.21H3.896ZM9.052 5.382v.457h3.896v-.457c-.015-.52-.21-.94-.584-1.26-.375-.322-.83-.483-1.364-.483-.535 0-.99.161-1.364.482-.374.32-.569.74-.584 1.26ZM5.5 18.443h11v-11h-1.948v2.75h-1.604v-2.75H9.052v2.75H7.448v-2.75H5.5v11Z",
    fill: "#000"
  })));
};
export default SvgShoppingBagInactive;